
import React, { useState } from 'react';
import { X, Plus } from 'lucide-react';

interface TagInputProps {
  tags: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
  colorClass?: string;
  id?: string;
}

const TagInput: React.FC<TagInputProps> = ({ tags, onChange, placeholder = "Add tag...", colorClass = "bg-slate-100 text-slate-700 border-slate-200", id }) => {
  const [input, setInput] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && input.trim()) {
      e.preventDefault();
      if (!tags.includes(input.trim())) {
        onChange([...tags, input.trim()]);
      }
      setInput('');
    }
  };

  const removeTag = (tagToRemove: string) => {
    onChange(tags.filter(t => t !== tagToRemove));
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2 mb-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium border ${colorClass}`}
          >
            {tag}
            <button
              onClick={() => removeTag(tag)}
              className="ml-1.5 p-0.5 hover:bg-black/10 rounded-full transition-colors"
            >
              <X size={10} />
            </button>
          </span>
        ))}
      </div>
      <div className="relative">
        <input
          id={id}
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className="w-full pl-3 pr-8 py-2 bg-white text-slate-900 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 transition-all placeholder:text-slate-400"
        />
        <button 
          onClick={() => {
            if (input.trim()) {
               if (!tags.includes(input.trim())) onChange([...tags, input.trim()]);
               setInput('');
            }
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-teal-600"
        >
          <Plus size={16} />
        </button>
      </div>
    </div>
  );
};

export default TagInput;
